const icon = document.querySelector('.new-header__drawer--icon');
const icon_text = document.querySelector('.new-header__drawer--icon .text');
const icon_open = document.querySelector('.new-header__drawer--icon .icons-open');
const icon_close = document.querySelector('.new-header__drawer--icon .icons-close');
const icon_inner = document.querySelector('.new-header__drawer--inner');
const body = document.querySelector('body');

header_mql = window.matchMedia('(max-width: 1000px)');

icon.addEventListener('click', () => {
    if (!header_mql.matches) {
        return false;
    } else {
        if (!icon.classList.contains('close')) {
            icon.classList.add('close');
            icon_open.classList.add('none');
            icon_close.classList.remove('none');
            icon.setAttribute('aria-label', 'メニューを閉じる');
            icon_text.textContent = '閉じる';
            icon_inner.classList.add('is-view');
            body.style.overflow = 'hidden';
        } else {
            icon.classList.remove('close');
            icon_open.classList.remove('none');
            icon_close.classList.add('none');
            icon.setAttribute('aria-label', 'メニューを開く');
            icon_text.textContent = 'メニュー';
            icon_inner.classList.remove('is-view');
            body.style.overflow = '';
        }
    }
});